<template>
    <v-card class="quiz-card">
      <v-card-title style="word-break: break-word;">
          {{question}}
      </v-card-title>
      <span v-if="image">
        <v-img :src="image"></v-img>
      </span>
      <v-card-actions>
        <v-radio-group v-if="optionType=='s'" class="options" v-model="selectionSingle">
            <v-radio 
              v-for="option in options" 
              :key="option.id" 
              :value="option.id"
              :label="option.answer_text"
            ></v-radio>
        </v-radio-group>
        <div v-else class="options">
        <v-checkbox multiple v-model="selectionMultiple" class="mt-0" v-for="option in options" :key="option.id" :value="option.id" :label="option.answer_text"></v-checkbox>
        </div>
        </v-card-actions>
        <v-card-actions align="left">
            <v-chip v-if="this.questionId in this.$store.state.selectedOptions" small>
                <v-icon left small>mdi-checkbox-marked-circle-outline</v-icon>
                Answered
            </v-chip>
            <v-chip v-else color="amber" text-color="secondary" small>
                Unanswered
            </v-chip>
        </v-card-actions>
    </v-card>
</template>

<script>

export default {
    name:'quizCard',   
    props:{
        image: String,
        question: String,
        questionId: Number,
        options: Array,
        optionType: String,
    },
    data() {
      return {
        selectionSingle: this.questionId in this.$store.state.selectedOptions ? this.$store.state.selectedOptions[this.questionId] : null,
        selectionMultiple:  this.questionId in this.$store.state.selectedOptions ? this.$store.state.selectedOptions[this.questionId] : []
      }
    },
    watch:{
        selectionSingle(newValue) {
            this.$store.commit('UPDATE_SELECTION', 
                {   optionId: newValue,
                    questionId: this.questionId,
                    optionType: this.optionType
                })
            },
        selectionMultiple(newValue) {
            this.$store.commit('UPDATE_SELECTION', 
                {   optionId: newValue,
                    questionId: this.questionId,
                    optionType: this.optionType
                })
            }
    },
}
</script>

<style scoped lang="scss">
.quiz-card {
    background-color: #F5F5F5 !important;
    width: 100%;
    height: min-content;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 1rem;
}

.question{
    font-size: 20px;
    margin: 20px 20px 10px 20px;
    font-weight: bold ;
}

.option {
  display:flex;

  & label {
    font-size: 20px;
  }

  & input {
    height: 15px;
  }
}

</style>